import React, { type ReactNode } from 'react';
import { toFlagId, type ShowFlagFn, type FlagId } from '@atlassian/jira-flags';
import CommonFlag from '@atlassian/jira-flags/src/common/ui/components/common-flag';

const FLAG_PTC_ID_DEFAULT = 'ptc-people-directory.flag-id';

type FlagFromPTC = {
	id: string;
	type: string;
	title?: ReactNode;
	description?: ReactNode;
};

export const createShowFlagHandler =
	(showFlag: ShowFlagFn, dismissFlag: (flagId: FlagId) => void) => (flagFromPTC: FlagFromPTC) => {
		const flagType =
			flagFromPTC.type === 'success' ||
			flagFromPTC.type === 'error' ||
			flagFromPTC.type === 'info' ||
			flagFromPTC.type === 'warning'
				? flagFromPTC.type
				: 'success';

		const flagTitle = flagFromPTC.title;
		const flagDesc = flagFromPTC.description;

		showFlag({
			render: ({ key }) => (
				<CommonFlag
					key={key}
					id={key || flagFromPTC.id || FLAG_PTC_ID_DEFAULT}
					flagType={flagType}
					title={flagTitle != null ? flagTitle : ''}
					description={flagDesc != null ? flagDesc : ''}
					isAutoDismiss
					onDismissed={(id) => {
						dismissFlag(toFlagId(id));
					}}
				/>
			),
		});
	};
